import React from 'react';
import { SvgIconProps } from './types';
import SvgIcon from './SvgIcon';

const Turnleft = (props: SvgIconProps) => (
    <SvgIcon {...props}>
        <path d="m6.83 11 1.59 1.59L7 14l-4-4 4-4 1.41 1.41L6.83 9H15c1.1 0 2 .9 2 2v9h-2v-9z" />
    </SvgIcon>
);

export default Turnleft;
